import { render, staticRenderFns } from "./RasConfigurazionePostiLettoPianiEditPage.vue?vue&type=template&id=634f5924"
import script from "./RasConfigurazionePostiLettoPianiEditPage.vue?vue&type=script&lang=js"
export * from "./RasConfigurazionePostiLettoPianiEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports